export enum FYMode {
    FYP = '100',
    FYU = '200',
}
